import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { Subject } from 'rxjs';
import { UnitService } from '../../services';
interface IUnitApplicationModalContext {
  title: string;
  data?: any;
}

function check(data: Array<any>, deviceArr) {
  for (let i = 0; i < data.length; i++) {
    var node = data[i];
    deviceArr.filter((eq) => eq.applicationId == node['applicationId'])[0]
      ? data.splice(i, 1)
      : '';
  }
  return data;
}
@Component({
  selector: 'app-unit-application-modal',
  templateUrl: './unit-application-modal.component.html',
  styleUrls: ['./unit-application-modal.component.scss'],
})
export class UnitApplicationModalComponent implements OnInit, OnDestroy {
  search: FormControl = new FormControl('');
  searchable: boolean = true;
  apps: Array<any> = [];
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  unit: any;
  newForm: FormGroup;
  collapseEquipment: boolean = true;
  applications: Array<any> = [];
  roles: Array<any> = [];
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private modalService: SuiModalService,
    private unitSvc: UnitService,
    public modal: SuiModal<IUnitApplicationModalContext, void, void>
  ) {
    this.newForm = fb.group({
      applicationId: ['', Validators.required],
      role: [null],
      owner: [false],
    });
    this.unit = modal.context.data['unit'];
    this.apps = modal.context.data['apps'];
    this.roles = modal.context.data['roles'];
    this.getApplications();
  }
  isFieldValid(field: string) {
    return (
      (!this.newForm.get(field).valid && this.newForm.get(field).touched) ||
      (this.newForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Aapplication?',
          'Are you sure you want to remove application?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }
  delete(app) {
    this.pending = true;
    this.unitSvc
      .deleteUnitApplication({
        organizationId: this.unit.organizationId,
        organizationUnitId: this.unit.organizationUnitId,
        applicationId: app.applicationId,
        body: {
          assign: false,
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Application removed from unit successfully';
          this.getApplications();
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  getRoleName(roleId) {
    let role = this.roles.filter((r) => r.roleId == roleId);
    if (role[0]) {
      return role[0].roleName;
    } else {
      return 'nil';
    }
  }
  submit() {
    console.log(this.newForm.value);
    if (this.newForm.valid) {
      this.unitSvc
        .addUnitApplication({
          id: this.unit.organizationUnitId,
          applicationId: this.newForm.value.applicationId,
          body: {
            assign: true,
            role: this.newForm.value.role,
            owner: this.newForm.value.owner,
          },
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Application added to unit successfully';
            this.collapseEquipment = !this.collapseEquipment;
            this.getApplications();
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
          }
        );
    }
  }

  getApplications() {
    this.pending = true;
    this.unitSvc
      .getUnitApplication({ id: this.unit.organizationUnitId })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.applications = res;
          this.apps = check(this.apps, res);
          console.log(res);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  save() {
    this.modal.approve(null);
  }
  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
}

export class UnitApplicationModal extends ComponentModalConfig<
  IUnitApplicationModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(UnitApplicationModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
